import { Box, CircularProgress, Heading, SimpleGrid } from '@chakra-ui/react';
import FolderGrid from './FolderGrid.js';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { apiEndPoint } from './StaticVar.js';
import MyLoading from './MyLoading.js';

function Photos(props) {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getPhotos()
  }, [])

  const getPhotos = async () => {
    const response = await fetch(apiEndPoint + "/api/image_collections");
    const json = await response.json();
    setData(json);
    setLoading(false);
  }

  return (
    loading ? <MyLoading /> :<Box p={6}>
      <Heading as="h1" mb={6} textAlign="center">Photo Gallery</Heading>
        <SimpleGrid
      columns={{ base: 1, sm: 2, md: 3, lg: 4 }}
      spacing={6}
      w="100%"
    >
          {data.map((imageimageCollection) => (
            <Link to={"/photos/" + imageimageCollection["id"]}>
              <FolderGrid
                key={imageimageCollection["id"]}
                folder={imageimageCollection}
              />
            </Link>
          ))}
        </SimpleGrid>
    </Box>
  )
}

export default Photos;
